import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import DatePicker from 'vue2-datepicker'
import PageTracker from '../../../common/PageTrackerHelper';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';


export default {
  name: 'UserOFDShipmentPayloadDetails',
  components: {BasicSelect,VueElementLoading,Paginate,DatePicker},
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      srList :[],
      srItemObj:{ value: "",text: ""},
      srId:'',
      srLoader :'',
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srArrayList : [],
      shipmentTypeArray:["Delivery","RTO","DTO","RVP"],
      shipmentType:'',
      ResponsePayload:'',
      ResponseError:"",
      isresponsepayload:false,
      isSearch:false,
      SearchLoading:false,
      pushOFDStatus:false,
      showPushUpdate:false,
      shipmentcount:0
    }
  },
  created: function(){

  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userrole = userdetail.userrole;
    this.userid = userdetail.userid
    this.localusermailid = userdetail.username;
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    this.loadSRList(this.userHubId)
  },
  methods: {
    clearAll(){
      this.isSearch = false
      this.SearchLoading = false
      this.isresponsepayload = false
      this.srId =''
      this.shipmentType =''
      this.ResponsePayload=''
      this.ResponseError=''
      this.srItemObj={ value: "",text: ""}
      this.showPushUpdate = false;
      this.shipmentcount = 0;
    },
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if(hubid) {
        this.input = {
          "usertype":"3",
          "hubid":[hubid]
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/users/HubDeliveryUsers/get/List',
          data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            this.srArrayList = result.data.data.results;
            for (var i = 0; i < this.srArrayList.length; i++) {
              this.srList.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
            }

          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    getSRs(obj){
      this.srItemObj = obj
      this.srId = this.srItemObj.value
    },
    getUserOFDShipmentPayload(scope){
      this.$validator.validateAll(scope).then(result => {
        if(result === true){
          this.isSearch = true
          this.SearchLoading = true
          this.isresponsepayload = false
          this.showPushUpdate = false;

          let input = {
            DeliveryUserId :this.srId,
            ShipmentType:this.shipmentType,
          }

          axios.post(apiUrl.api_url + "websupport/get/user/ofd/shipments",input)
          .then(async result =>{
            this.SearchLoading=false
            if (result.data.code === 200){
             this.ResponsePayload = JSON.stringify(result.data.data,null,1)
             this.isresponsepayload = true
             this.showPushUpdate = true;
             this.shipmentcount = result.data.data.ShipmentCount;
            }else {
              this.ResponsePayload = '';
              this.ResponseError = result.data.message
              this.isresponsepayload = false
              this.SearchLoading=false;
              this.showPushUpdate = false;
            }
          }).catch(err => {
            this.SearchLoading=false
            console.log("Error Details", err);
          });
        }
      })
    },
    updatePushOFDStatus(){
      this.SearchLoading = true
      let input = {
        DeliveryUserId :this.srId,
        ShipmentType:this.shipmentType,
        PushUpdate:this.pushOFDStatus
      }
      axios.post(apiUrl.api_url + "websupport/get/user/ofd/shipments",input)
      .then(async result =>{
        let TrackerInfo = {
          projectname:"Last Mile",
          type:"Web",
          userid:this.userid,
          username:this.localusermailid,
          meta: {
            "event":"updateOFDShipments",
            "DeliveryUserId" :this.srId,
            "ShipmentType":this.shipmentType,
            "PushUpdate":this.pushOFDStatus
          }
        }
        this.PageTracker(TrackerInfo);
        this.SearchLoading = false;
        this.showPushUpdate = false;
        this.pushOFDStatus = false;
      }).catch(err => {
        this.SearchLoading=false;
        this.pushOFDStatus = false;
        console.log("Error Details", err);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UserOFDShipmentPayloadDetails/UserOFDShipmentPayloadDetails.component.js